import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 22h1a4 4 0 0 0 4-4v-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 2h1a4 4 0 0 1 4 4v1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TextCursor";
const TextCursor = memo(themed(Icon));
export {
  TextCursor
};
//# sourceMappingURL=text-cursor.js.map
